import React, { useState, useEffect } from 'react';
import { MQTTProtocol } from '../setup-senzmatica/connect-devices/MQTTProtocol';
import { HTTPProtocol } from '../setup-senzmatica/connect-devices/HTTPProtocol';
import useStyles from '../maintenance/assets/styles';
export function DeviceForm({
  onClose,
  onSubmit,
  allDevices,
  isCloning,
  selectedDevice,
  formType,
  sensors,
  actuators,
  batches,
  allProducts,
  hasPermissionFor,
  setCodecId,
  codecs,
  setLoading
}) {
  // Form state
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    interval: '',
    persistence: false,
    protocol: '',
    connectivity: 'GSM',
    batchNumber: '',
    simNumber: '',
    sensorCodes: [],
    actuatorCodes: [],
    productType: '',
  });

  const style = useStyles();
  const [sensorsOfDevice, setSensorsOfDevice] = useState([]);
  const [actuatorsOfDevice, setActuatorsOfDevice] = useState([]);
  const [addCredentialsSuccess, setAddCredentialsSuccess] = useState(false);
  const [credentialsError, setCredentialsError] = useState(false);
  const [isProtocolAdded, setIsProtocolAdded] = useState(false);
  const [clientId, setClientId] = useState("");
  const [isAdding, setIsAdding] = useState(true);
  const [isAddBatchClick, setIsAddBatchClick] = useState(false);
  const [batchError, setBatchError] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState("");

  const [errors, setErrors] = useState({
    id: null,
    name: null,
    interval: null,
    persistence: null,
    protocol: null,
    connectivity: null,
    batchNumber: null,
    sensorCodes: null,
    actuatorCodes: null,
    productType: null,
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    console.log(selectedDevice);
    if(formType === "EDIT") {
      setIsAdding(false);
      setCredentialsError(false);
      setAddCredentialsSuccess(true);
      setIsProtocolAdded(true);
    }
    if (selectedDevice) {

      setFormData({
        id: selectedDevice.id || '',
        name: selectedDevice.name || '',
        interval: selectedDevice.interval.toString() || '',
        persistence: selectedDevice.persistence ? true : false,
        protocol: selectedDevice.protocol || 'MQTT',
        connectivity: selectedDevice.connectivity || 'GSM',
        batchNumber: selectedDevice.batchNumber || '',
        simNumber: selectedDevice.simNumber || '',
        sensorCodes: selectedDevice.sensorCodes || [],
        actuatorCodes: selectedDevice.actuatorCodes || [],
        productType: selectedDevice.productType || '',
      });

      setSensorsOfDevice(selectedDevice.sensorCodes || []);
      setActuatorsOfDevice(selectedDevice.actuatorCodes || []);
    }
  }, [selectedDevice]);

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "productType") {
      setErrors((prevError) =>({
        ...prevError,
        productType:null
      }))
      const product = allProducts.find(p => p.productName === value);
      if (product.codecName) {
        const filterCodec = codecs.find(codec => codec.codecName == product.codecName)
        setCodecId(filterCodec.id)
      }
      if (product) {
        setFormData(prev => ({
          ...prev,
          productType: product.productName,
          persistence: product.persistence,
          protocol: product.protocol,
          connectivity: product.connectivity,
          sensorCodes: product.sensorCodes || [],
          actuatorCodes: product.actuatorCodes || [],
        }));
        setSensorsOfDevice(product.sensorCodes || []);
        setActuatorsOfDevice(product.actuatorCodes || []);
      }
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prevError) =>({
      ...prevError,
      [name]:null
    }))
  };

  const handleBatchNumberChange = (value) => {
    setFormData(prev => ({ ...prev, batchNumber: value }));
    setIsAddBatchClick(false);
    setErrors((prevError) =>({
      ...prevError,
      batchNumber:null
    }))
  };

  const keyPress = (e) => {
    if (e.keyCode == 13) {
      console.log(e.target.value)
      setIsAddBatchClick(false);
      batches.push(e.target.value);
      setSelectedBatch(e.target.value)
      setBatchError(false);
      setFormData({
        ...formData,
        batchNumber: e.target.value
      });
    }
  }

  const validate = () => {
    let error: any = {}

    if (!formData.id.trim()) {
      error.id = 'Device Id is required';
    } else if (
      formType !== "EDIT" &&
      allDevices.some(device => device.id === formData.id.trim())
    ) {
      error.id = 'Device Id already exists';
    }

    if (!formData.name.trim()) {
      error.name = 'Device Name is required';
    } else if (
      formType !== "EDIT" &&
      allDevices.some(device => device.name === formData.name.trim())
    ) {
      error.name = 'Device Name already exists';
    }

    if (!formData.interval.trim()) {
      error.interval = 'Interval is required';
    } else if (isNaN(Number(formData.interval))) {
      error.interval = 'Interval must be a number';
    }

    if (sensorsOfDevice.length === 0 && actuatorsOfDevice.length === 0) {
      error.sensorCodes = 'At least one Sensor or Actuator must be added';
      error.actuatorCodes = 'At least one Sensor or Actuator must be added';
    }

    if (!formData.batchNumber.trim()) {
      error.batchNumber = 'Batch Number is required';
    }

    if (!formData.protocol.trim()) {
      error.protocol = 'Protocol is required';
    } else if (!isProtocolAdded) {
      error.protocol = 'A protocol must be added to the device';
      setCredentialsError(true);
      setAddCredentialsSuccess(false);
    }

    if (!formData.connectivity.trim()) {
      error.connectivity = 'Connectivity is required';
    }

    if (!formData.productType.trim()) {
      error.productType = 'Product Type is required';
    } else if (
      formType !== "EDIT" &&
      !allProducts.some(product => product.productName === formData.productType)
    ) {
      error.productType = 'Invalid Product Type';
    }

    return error;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    const validationErrors = validate();
    console.log("Validation Errors:", validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({
      id: null,
      name: null,
      interval: null,
      persistence: null,
      protocol: null,
      connectivity: null,
      batchNumber: null,
      sensorCodes: null,
      actuatorCodes: null,
      productType: null,
    });
    const finalData = {
      ...formData,
      sensorCodes: sensorsOfDevice,
      actuatorCodes: actuatorsOfDevice,
      persistence: formData.persistence,
      noOfSensors: sensorsOfDevice.length,
      noOfActuators: actuatorsOfDevice.length,
      metaData: {
        simNumber: formData.simNumber || null,
      },
    };

    onSubmit(finalData);
  };

  const handleSuccess = (success) => {
    console.log("Credentials Success:", success);
    if (success) {
      setCredentialsError(false);
      setAddCredentialsSuccess(true);
      setIsProtocolAdded(true);
    } else {
      setCredentialsError(true);
      setAddCredentialsSuccess(false);
      setIsProtocolAdded(false);
    }
  };

  return (
    <div className="modal_HighZindex2">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            {formType === "ADD" ? 'Add New' : formType === "CLONE" ? 'Clone' : 'Edit'} Device
            <button
              type="button"
              className="modal-close"
              onClick={() => {
                setErrors(null);
                onClose();
              }}
            >
              &times;
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body"  style={{ paddingBottom: "20px" }}>
              {/* Device Id */}
              <div className="form-entity custom-form-entity">
                <div className="form-field">
                  <label className="form-label" htmlFor="deviceIdInput">
                    Device Id (IMEI) <span className="required-asterisk" style={{color: "red"}}>*</span>
                  </label>
                  <input
                    id="deviceIdInput"
                    name="id"
                    value={formData.id}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Enter Device Id"
                    type="text"
                  />
                  {errors.id && <span className="form-error">{errors.id}</span>}
                </div>

                {/* Device Name */}
                <div className="form-field">
                  <label className="form-label" htmlFor="deviceNameInput">
                    Device Name <span className="required-asterisk" style={{color: "red"}}>*</span>
                  </label>
                  <input
                    id="deviceNameInput"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Enter Device Name"
                    type="text"
                  />
                  {errors.name && <span className="form-error">{errors.name}</span>}
                </div>
              </div>

              {/* Product Type */}
              <div className="form-entity custom-form-entity">
                <div className="form-field">
                  <label className="form-label" htmlFor="productSelect">
                    Product Type <span className="required-asterisk" style={{color: "red"}}>*</span>
                  </label>
                  <select
                    id="productSelect"
                    name="productType"
                    className="form-input selector"
                    value={formData.productType}
                    onChange={handleInputChange}
                    placeholder='Select Product Type'
                  >
                    <option value="" disabled hidden>Select Product Type</option>
                    {allProducts.map((product, index) => (
                      <option key={index} value={product.productName}>
                        {product.productName}
                      </option>
                    ))}
                  </select>
                  {errors.productType && <span className="form-error">{errors.productType}</span>}
                </div>
              </div>

              {formData.protocol && isAdding && (
                <>
                  {formData.protocol === "MQTT" && (
                    <MQTTProtocol
                      protocol={formData.protocol}
                      onSuccess={handleSuccess}
                      credentialsError={credentialsError}
                      setClientId={setClientId}
                      setLoading={setLoading}
                    />
                  )}
                  {formData.protocol === "HTTP" && (
                    <HTTPProtocol
                      protocol={formData.protocol}
                      onSuccess={handleSuccess}
                      credentialsError={credentialsError}
                      setClientId={setClientId}
                      setLoading={setLoading}
                    />
                  )}
                </>
              )}

              {/* Interval */}
              <div className="form-entity custom-form-entity">
                <div className="form-field">
                  <label className="form-label" htmlFor="intervalInput">
                    Interval (Minutes) <span className="required-asterisk" style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    id="intervalInput"
                    name="interval"
                    value={formData.interval}
                    onChange={handleInputChange}
                    className="form-input"
                    placeholder="Enter Interval"
                    type="text"
                  />
                  {errors.interval && <span className="form-error">{errors.interval}</span>}
                </div>

                {/* Batch */}
                <div className="form-field">
                  <label className="form-label" htmlFor="batchInput">
                    Batch <span className="required-asterisk" style={{color: "red"}}>*</span>
                  </label>

                  <div className='form-label-container'>
                    <select
                      id="batchInput"
                      name="batchNumber"
                      className="form-input selector"
                      value={formData.batchNumber}
                      onChange={(e) => handleBatchNumberChange(e.target.value)}
                    >
                      <option value="" disabled hidden>Select Batch Number</option>
                      {batches.map((batch, index) => (
                        <option key={index} value={batch}>
                          {batch}
                        </option>
                      ))}
                    </select>

                    <button
                      type="button"
                      className="btn btn-default"
                      style={{ backgroundColor: '#2A7CED', color: 'white', marginRight: '0px' }}
                      onClick={() => setIsAddBatchClick(true)}
                    >
                      New
                    </button>
                  </div>

                  {/* Show input when "New" is clicked */}
                  {isAddBatchClick && (
                    <input
                      className={style.formInput}
                      type="text"
                      placeholder="Enter New Batch"
                      name="batchNumber"
                      onKeyDown={(e) => keyPress(e)}
                    />
                  )}
                  {errors.batchNumber && <span className="form-error">{errors.batchNumber}</span>}
                </div>
              </div>

              
              </div>

              <div className="modal-footer-new">
                <button
                  type="submit"
                  className="btn btn-default"
                  style={{ backgroundColor: '#2A7CED', color: 'white' }}
                >
                  {formType === "ADD" ? 'Add ' : formType === "CLONE" ? 'Clone' : 'Update'} Device
                </button>
              </div>
          </form>
        </div>
      </div>
    </div>
  );
}
